'use client';

import { Separator as SeparatorPrimitive } from '@base-ui/react/separator';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@ui/lib/utils';

enum SeparatorVariant {
  DEFAULT = 'default',
  CARD = 'card',
}

const separatorVariants = cva('', {
  variants: {
    variant: {
      [SeparatorVariant.DEFAULT]: '',
      [SeparatorVariant.CARD]: '-mx-5 my-4 w-auto',
    },
  },
  defaultVariants: {
    variant: SeparatorVariant.DEFAULT,
  },
});

interface SeparatorProps extends SeparatorPrimitive.Props, Omit<VariantProps<typeof separatorVariants>, 'variant'> {
  variant?: SeparatorVariant;
}

export const Separator = ({ className, orientation = 'horizontal', variant, ...props }: SeparatorProps) => {
  return (
    <SeparatorPrimitive
      data-slot="separator"
      data-variant={variant}
      orientation={orientation}
      className={cn(
        'shrink-0 bg-border',
        orientation === 'horizontal' ? 'h-px w-full' : 'w-px self-stretch',
        separatorVariants({ variant }),
        className
      )}
      {...props}
    />
  );
};

export { SeparatorVariant };
